export default __webpack_public_path__ + "static/media/noun-distribution-2764037.69e18bbf.svg";